module.exports = __webpack_public_path__ + "img/eventBannerHomeIcon.13132444.svg";